import { Component } from '@angular/core'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'
import { AppRoutesNS } from '../../../app-routes.namespace'
import { ConfigurationService } from '../../../shared/services/configuration.service'

@Component({
  selector: 'primary-navbar-pending-sale-block',
  templateUrl: './show.component.html'
})
export class PrimaryNavbarPendingSaleBlockComponent {
  constructor(public configurationService: ConfigurationService) {}

  public showMyShoppingInMobile$(): Observable<boolean> {
    return this.configurationService
      .isRouteAllowedOnMobileApp$(AppRoutesNS.Members.PROFILE_MYSHOPPING)
      .pipe(take(1))
  }
}
